import { useTranslation } from "react-i18next"
import { LogOut } from "@styled-icons/feather/LogOut"
import { useAuth } from "customerAttachments/auth/AuthProvider"
import { useModal } from "customerAttachments/contexts/ModalProvider"
import useWindowDimensions, { DeviceType } from "customerAttachments/hooks/useWIndowDimensions"
import { GogoroSvg } from "views/components/Icon"

import styles from "./styles.module.scss"

const Header = () => {
  const { deviceType } = useWindowDimensions()
  const { logout } = useAuth() || {}
  const { openModal } = useModal()
  const { t } = useTranslation(["sales", "label"])
  const isDesktop = deviceType === DeviceType.DESKTOP

  const openLogoutDialog = () => {
    openModal({
      title: t("label:logout"),
      content: t("label:logout.confirm_text"),
      onConfirm: logout,
    })
  }

  if (isDesktop) {
    return (
      <div className={styles.desktopHeader}>
        <div className={styles.desktopHeader_content}>
          <div className={styles.desktopHeader_titleContainer}>
            <GogoroSvg className={styles.logo} />
            <div className={styles.desktopHeader_title}>
              {t("customer_attachments.private_information_file_upload")}
            </div>
          </div>
          <div className={styles.logout} onClick={openLogoutDialog}>
            {t("label:logout")}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.mobileHeader}>
      <div className={styles.mobileHeader_title}>{t("customer_attachments.private_information_file_upload")}</div>
      <LogOut className={styles.logoutIcon} size={24} onClick={openLogoutDialog} />
    </div>
  )
}

export default Header
